import { LeveransResponseDto } from "~app/common/models/integration/viol3/LeveransResponseDto";
import { DateUtils } from "~app/common/utils/date-utils";

export class LeveransRowVm {
    matdatum: string;
    redovisningsdatum: string;
    beteckning: string;
    befraktareKod: string;
    kundKod: string;
    avtalsobjekt: string;
    redovisningshanvisning: string;
    transportnummer: string;
    leveransnummer: string;
    verkligtLeveransdatum: string;
    mottagningsplatsnummer: string;
    kundordernummer: string;
    leverantorsordernummer: string;
    allaMatningstjansterKorda: boolean;
    harKorrektioner: boolean;
    senasteAnkomstmatning: string;
    senasteVederlagsmatning: string;
    kontrakt: string;
    koder: string;
    kvantitet: string;
    ordrar: string;
    datum: string;

    constructor(dto: LeveransResponseDto) {
        this.matdatum = dto.matdatum;
        this.redovisningsdatum = dto.redovisningsdatum;
        this.beteckning = dto.beteckning;
        this.befraktareKod = dto.befraktareKod;
        this.kundKod = dto.kundKod;
        this.avtalsobjekt = dto.avtalsobjekt;
        this.kontrakt = this.formatKontrakt(dto);
        this.redovisningshanvisning = dto.redovisningshanvisning;
        this.transportnummer = dto.transportnummer;
        this.leveransnummer = dto.leveransnummer;
        this.koder = this.formatKoder(dto);
        this.kvantitet = this.formatKvantiteter(dto);
        this.ordrar = this.formatOrdrar(dto);
        this.verkligtLeveransdatum = dto.verkligtLeveransdatum;
        this.mottagningsplatsnummer = dto.mottagningsplatsnummer;
        this.kundordernummer = dto.kundordernummer;
        this.leverantorsordernummer = dto.leverantorsordernummer;
        this.allaMatningstjansterKorda = dto.allaMatningstjansterKorda;
        this.harKorrektioner = dto.harKorrektioner;
        this.datum = this.formatDatum(dto);
        this.senasteAnkomstmatning = dto.senasteAnkomstmatning;
        this.senasteVederlagsmatning = dto.senasteVederlagsmatning;

    }

    formatKvantiteter(row: LeveransResponseDto): string {
        return row.kvantiteter
            .map(p => `[${p.inmatningshandelssortiment ?? ""}/${p.produceratHandelssortiment ?? ""}] ${p.mattslagskvalitet}:${p.mattslag}:${p.kvantitet}:${p.avdragenKvantitet}`)
            .join("\r\n");
    }

    formatKontrakt(row: LeveransResponseDto): string {
        const values = [
            `In: ${row.kontraktIn ?? ""}`,
            `Ut: ${row.kontraktUt ?? ""}`,
            `RH: ${row.redovisningshanvisning ?? ""}`
        ];
        return values.join("\r\n");
    }

    formatOrdrar(row: LeveransResponseDto): string {
        const values = [
            `Mpl.nr   : ${this.formatMottagningsplats(row)}`,
            `Kundorder: ${row.kundordernummer ?? ""}`,
            `Lev.ord  : ${row.leverantorsordernummer ?? ""}`
        ];
        return values.join("\r\n");
    }

    formatMottagningsplats(row: LeveransResponseDto): string {
        if (!row.avlastningsplats) {
            return row.mottagningsplatsnummer ?? "";
        }

        return `${row.mottagningsplatsnummer ?? ""}/${row.avlastningsplats}`;
    }

    formatKoder(row: LeveransResponseDto): string {
        const values = [
            `Kund    : ${row.kundKod ?? ""}`,
            `Slutkund: ${row.slutkundKod ?? ""}`,
            `Befrakt.: ${row.befraktareKod ?? ""}`,
            `Leveran.: ${row.leverantorKod ?? ""}`
        ];
        return values.join("\r\n");
    }

    formatDatum(row: LeveransResponseDto): string {
        const values = [
            `Redovisningsdatum: ${DateUtils.shortDateString(row.redovisningsdatum) ?? ""}`,
            `Verkl. leverans  : ${DateUtils.shortDateString(row.verkligtLeveransdatum) ?? ""}`,
            `S.Ankomst.Mtn.   : ${DateUtils.shortDateString(row.senasteAnkomstmatning) ?? ""}`,
            `S.Vederlag.Mtn.  : ${DateUtils.shortDateString(row.senasteVederlagsmatning) ?? ""}`
        ];

        return values.join("\r\n");
    }
}
